import { PhoneBookEntry } from '../types';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface WhatsAppButtonProps {
  contact: PhoneBookEntry;
  size?: 'sm' | 'md' | 'lg';
}

export const WhatsAppButton = ({ contact, size = 'md' }: WhatsAppButtonProps) => {
  const { user, profile } = useAuth();
  const navigate = useNavigate();

  const digits = contact.phone_number.replace(/\D/g, '');
  const padding = size === 'sm' ? 'px-2 py-1 text-xs' : size === 'lg' ? 'px-4 py-2 text-base' : 'px-3 py-1.5 text-sm';

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (!user) {
      navigate('/login');
      return;
    }
    try {
      await supabase.from('contact_view_audit').insert({
        viewer_user_id: user.id,
        viewer_name: profile?.full_name ?? null,
        viewer_mobile: profile?.phone ?? null,
        contact_id: contact.id,
        contact_name: contact.name,
        contact_mobile: contact.phone_number,
      });
    } catch {
      // ignore audit failures
    }
    window.open(`https://wa.me/${digits}`, '_blank');
  };

  return (
    <a
      href={!user ? '/login' : `https://wa.me/${digits}`}
      onClick={handleClick}
      className={`inline-flex items-center gap-1 rounded-full bg-green-600 font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 ${padding}`}
      aria-label={`WhatsApp ${contact.name}`}
    >
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden="true">
        <path d="M12.04 2C6.51 2 2 6.39 2 11.8c0 1.89.56 3.66 1.52 5.15L2 22l5.29-1.39A9.78 9.78 0 0012.04 21.6c5.53 0 10.04-4.39 10.04-9.8S17.57 2 12.04 2zm5.6 13.89c-.24.67-1.39 1.32-1.93 1.4-.52.08-1.02.24-3.05-.66-2.56-1.06-4.2-3.67-4.32-3.84-.12-.17-1.03-1.36-1.03-2.6s.65-1.86.88-2.11c.23-.25.51-.32.68-.32.17 0 .34 0 .49.01.16.01.36-.06.56.43.2.49.68 1.65.74 1.77.06.12.1.26.02.42-.08.16-.12.26-.24.4-.12.14-.25.29-.36.39-.12.1-.24.21-.1.43.14.22.62.99 1.34 1.61.92.81 1.69 1.06 1.93 1.18.24.12.38.1.52-.06.14-.16.6-.7.76-.94.16-.24.32-.2.52-.12.2.08 1.31.62 1.53.73.22.11.37.17.42.27.06.1.04.58-.2 1.25z" />
      </svg>
      <span>WhatsApp</span>
    </a>
  );
};
